<template>
    <div class="text-xs-center">
    
    <v-dialog
      v-model="not.notShow" 
      :persistent="not.notHd"
      width="300"
    >
      <v-card
        :color="not.notCl"
        dark class="pa-2"
      >
        <v-card-text >
          {{not.notTx}}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
    props:['notShow','notHd', 'notTx','notCl'],
    created(){    
    },
     updated(){
         
         //console.log("dialog updated");  
    },
    data(){
        return{
            show:false,

        }
       
    },
   
    computed:{
        not(){
            return  this.$store.getters.getNotDialogP
        }
    },
    methods:{
        onNotNo(){
            this.$emit('notNo')
            this.$store.dispatch('setNotDialog',{}) 
        },
        onNotYes(){
            this.$emit('notYes')
            this.$store.dispatch('setNotDialog',{})
        }
    },
    watch:{
        not(value){
           //console.log(value,"wwwwwwwwww");  
        },
         
    } 
}
</script>
